export default {
  relationship: {
    title: "Зв'язок платежів і пачок",
    linkForm: {
      modal: {
        title: "Зв'язок платежу і пачки"
      },
      form: {
        cardPayment: {
          header: "Платіж"
        },
        cardPack: {
          header: "Пачка"
        },
        codefirme: {
          title: "Організація"
        },
        datebank: {
          title: "Дата з банку"
        },
        datepay: {
          title: "Дата оплати"
        },
        summa: {
          title: "Сума"
        },
        sumprof: {
          title: "За послуги"
        },
        status: {
          title: "Сума платежу включає в себе комісійний збір"
        },
        quantity: {
          title: "Квитанцій"
        },
        countband: {
          title: "Бандероль"
        },
        difference: {
          title: "Розбіжність між сумами платежу і пачки"
        },
        userid: {
          title: "Призначений оператор"
        }
      }
    },
    searchErrorPaymentsForm: {
      modal: {
        title: "Пошук помилкового платежу"
      },
      form: {
        abcode: "Особовий рахунок",
        sumPay: "Сума платежу",
        dateBank: "Дата по банку",
        datePay: "Дата оплати",
        dateChange: "Дата зміни",
        and: "і",
        errorType: "Тип помилки",
        npack: "Номер пачки",
        datePayFrom: "Період оплати з",
        datePayTo: "по",
        kindpay: "Тип оплати",
        codefirme: "Платник",
        note: "Примітка"
      },
      extendedSearch: "F2 - Розширений пошук",
      confirm: {
        searchTermNotSpecified:
          "Не вказана умова пошуку. Показати усі платежі?",
        veryMuchPayments:
          "Таких платежів може бути дуже багато і їх завантаження може зайняти тривалий час. Ви упевнені, що хочете побачити усі такі платежі?"
      }
    },
    errorPaymentsForm: {
      modal: {
        title: "Виправлення та рознесення помилкових платежів"
      },
      autoDistribute: "F2 - Автоматично рознести платіж після зміни"
    },
    paymentsRelationColumn: {
      headers: {
        paymentsRelation: "Платежі"
      }
    },
    packsRelationColumn: {
      headers: {
        packsRelation: "Пачки"
      }
    },
    packsInternetRelationColumn: {
      headers: {
        packsInternetRelation: "Internet-пачки"
      }
    },
    linkConfirm: {
      title: "Зв'язок платежу і пачки",
      linkPayment: "Зв'язати платіж",
      for: "за",
      from: "від",
      inAmount: "на суму",
      withRecPay: "з поданими оплатами",
      pcs: "шт",
      attention:
        "Увага! Дані платежу і пачки відрізняються один від одного. Чи бажаєте зв'язати їх в будь-якому випадку?"
    },
    linkResultTitle: "Результат"
  }
};
